import LangEnum from '../../../lang/LangEnum';
import OrderContractSignatureRequired from '../enums/orderContractSignatureRequired.enum';

export const getContractSignatureSettingItemLangEnum = (value: OrderContractSignatureRequired) => {
  const mappedLangEnum: {
    [key in OrderContractSignatureRequired]: LangEnum;
  } = {
    [OrderContractSignatureRequired.BY_NONE]: LangEnum.ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_NONE,
    [OrderContractSignatureRequired.BY_STORE]: LangEnum.ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE,
    [OrderContractSignatureRequired.BY_STORE_AND_BRAND]:
      LangEnum.ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE_AND_BRAND,
  };
  return mappedLangEnum[value];
};
